let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6RmSY")).then(() => parcelRequire('4pG8m'));